import { makeStyles } from '@material-ui/core/styles';
import SolutionsIcon1 from '../../img/survey-icon.png';
import SolutionsIcon2 from '../../img/workflow-icon.png';
import SolutionsIcon3 from '../../img/mobile-icon.png';
import SolutionsIcon4 from '../../img/hosting-icon.png';
import SolutionsIcon5 from '../../img/dev-icon.png';
import SolutionsIcon6 from '../../img/cms-icon.png';
import rciImage from '../../img/stock-photo.jpg';


const solutionsClasses = makeStyles((theme) => ({
  solutionsInnerStyle: {
    paddingTop:10,
    paddingBottom:20,
    [theme.breakpoints.up('md')]: {
      paddingBottom: 100,
      paddingTop: 50,
    },
  },
  rciImg: {
    backgroundImage:`url(${rciImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
    theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    minHeight:500,
    borderRadius: 30,
    marginRight: 30,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginLeft: 0,
      minHeight: 300,
    },
  },
  solutionsImg: {
    maxHeight: 125,
    width: 'auto',
    marginBottom: 20,
    marginTop: 20,
  },
  customSolutions1: {
    backgroundImage:`url(${SolutionsIcon1})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'left',
    height: 100,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      backgroundImage: 'none',
    },
  },
  customSolutions2: {
    backgroundImage:`url(${SolutionsIcon2})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'left',
    height: 100,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      backgroundImage: 'none',
    },
  },
  customSolutions3: {
    backgroundImage:`url(${SolutionsIcon3})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'left',
    height: 100,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      backgroundImage: 'none',
    },   
  },
  customSolutions4: {
    backgroundImage:`url(${SolutionsIcon4})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'left',
    height: 100,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      backgroundImage: 'none',
    },   
  },
  customSolutions5: {
    backgroundImage:`url(${SolutionsIcon5})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'left',
    height: 100,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      backgroundImage: 'none',
    },    
  },
  customSolutions6: {
    backgroundImage:`url(${SolutionsIcon6})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'left',
    height: 100,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      backgroundImage: 'none',
    },    
  },
  customSolutionsText: {
    width: '70%',
    paddingLeft: 40,
    [theme.breakpoints.down('md')]: {
      alignSelf: 'left',
      paddingLeft: 0,
      paddingRight: 30,
  },
},
  customSolutionsSubtext: {
    paddingLeft: 20,
    lineHeight: 1.8,
    paddingBottom: 50,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
  },
},
  servicesContainer: {
    paddingLeft: 0,
    paddingRight: 0,
    backgroundColor: '#B7D8DF',
    clipPath: 'polygon(0 0, 100% 9%, 100% 96%, 0 100%)',
  },
  servicesContainer2: {
    padding: 100,
    paddingLeft: 0,
    paddingRight: 0,
    backgroundColor: '#FFFBE9',
    clipPath: 'polygon(0 0, 100% 14%, 100% 88%, 0 100%)',
  },
  servicesList: {
    padding: '0 20px 20px 20px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10,
  },
},


}));

  
  export default solutionsClasses